import { render, staticRenderFns } from "./projectsTemplate.vue?vue&type=template&id=566b0d67&"
import script from "./projectsTemplate.vue?vue&type=script&lang=js&"
export * from "./projectsTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports